module.exports = __webpack_public_path__ + "img/microneedling-treatment-mobile-fr.042c885f.jpg";